import React, { ComponentType } from 'react';
import { Validation } from '@e2m-customer-portal/shared';
import { useInputValidation } from '@e2m-customer-portal/hooks';

type WithValidationProps<T, K extends keyof T> = T & {
  name: string;
  rules?: Validation<T[K]>[];
  onBlur?: () => void;
};

export function validatedInput<T, K extends keyof T>(
  Component: ComponentType<T>,
  valueKey: K,
): ComponentType<WithValidationProps<T, K>> {
  return function ValidatedInput(props) {
    const { error, message, handleBlur } = useInputValidation(props.name, props.rules, props[valueKey], props.onBlur);
    return <Component {...props} error={error} helperText={message} onBlur={handleBlur} />;
  };
}
